import DOMPurify from 'dompurify';
import { useTranslation } from 'react-i18next';

import { auth } from '../../../services/auth';
import { intercom } from '../../../services/intercom';
import { useStores } from '../../../stores/useStores';
import Button from '../../buttons/Button';
import { Dialog } from '../../Dialog/Dialog';
import { I18Text } from '../../i18Next/I18Text';

import styles from './AccountLockedDialog.module.scss';

const AccountLockedDialog = () => {
  const { authStore, portalStore } = useStores();
  const { t } = useTranslation();
  const isDirectLanding = authStore.isDirectLanding();

  const onClose = () => {
    portalStore.closePortal();
  };

  const handleOpenSupport = () => {
    if (!isDirectLanding) {
      portalStore.closePortal();
    }

    intercom.handleOpenSupport();
  };

  const renderMessage = () => {
    if (auth.selfExclusionCustomMsg) {
      if (auth.selfExclusionCustomMsg.isHtml) {
        const sanitizedText = DOMPurify.sanitize(auth.selfExclusionCustomMsg.playerNotificationText, {
          FORBID_TAGS: ['script', 'iframe', 'object', 'embed', 'form', 'input'],
          FORBID_ATTR: ['onerror', 'onload', 'onclick', 'onmouseover', 'onfocus', 'onblur', 'onchange', 'onsubmit'],
          ALLOWED_URI_REGEXP: /^(?!javascript:).*/i, // block javascript: URLs
        });

        return <p dangerouslySetInnerHTML={{ __html: sanitizedText }} />;
      }

      return <p>{auth.selfExclusionCustomMsg.playerNotificationText}</p>;
    }

    return (
      <>
        <p>
          {t('account.itSeemsYour')} <b>{t('account.isLocked')}</b>
        </p>
        <b>
          <I18Text i18nKey="account.pleaseContactCustomerSupport" />
        </b>
      </>
    );
  };

  return (
    <Dialog
      forceNewDialogStyle
      isOpen
      classNameBackdrop={styles.backdrop}
      classNameParent={styles.dialog}
      title={t('account.locked')}
      onBackdropClick={onClose}
      onClose={onClose}
    >
      <div className={styles.content}>{renderMessage()}</div>

      <Button btnType="main" className={styles.okBtn} onClick={handleOpenSupport}>
        {t('common.contactSupportUpperCase')}
      </Button>
    </Dialog>
  );
};

export default AccountLockedDialog;
